import Dashboard from './components/Dashboard';
import FarmersList from './components/Farmers/FarmersList';
import FarmerProfile from './components/Farmers/FarmerProfile';
import IrrigationEntry from './components/Irrigation/IrrigationEntry';

export const routes = [
  {
    path: '/',
    component: Dashboard,
    exact: true,
  },
  {
    path: '/farmers',
    component: FarmersList,
    exact: true,
  },
  {
    path: '/farmers/:id',
    component: FarmerProfile,
  },
  {
    path: '/irrigation/new',
    component: IrrigationEntry,
  },
  {
    path: '/water-records',
    component: IrrigationEntry,
  },
];
